module.exports = require('../../full/object');
